import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, GuardResult, Router, RouterStateSnapshot } from '@angular/router';
import { AppRoutingService } from '@core/app-routing.service';
import { GuardHelpers } from '@guards/guard-helpers';

export const forceCorrectLoginPageGuard = GuardHelpers.wrapWithLogs(
  'forceCorrectLoginPageGuard', (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): GuardResult => {
    const appRoutingService = inject(AppRoutingService);

    const router = inject(Router);
    const correctLoginUrl = appRoutingService.findLoginRoute().toString();
    if (_state.url === correctLoginUrl) {
      // already there, allow through guard
      return true;
    }
    // redirect to correct login url
    return router.createUrlTree([correctLoginUrl], { queryParamsHandling: 'preserve' });
  }
) satisfies CanActivateFn;
